import { render, staticRenderFns } from "./InstructorRegistrationsSnapshot.vue?vue&type=template&id=258771d4&scoped=true"
import script from "./InstructorRegistrationsSnapshot.vue?vue&type=script&lang=js"
export * from "./InstructorRegistrationsSnapshot.vue?vue&type=script&lang=js"
import style0 from "./InstructorRegistrationsSnapshot.vue?vue&type=style&index=0&id=258771d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258771d4",
  null
  
)

export default component.exports